import React from 'react';
import HistoryService from 'services/HistoryService'
import { SecondaryButton, ButtonArrowState } from '@huggg/react-components'
import { backButton as backButtonCopy } from 'config/dictionary'
import styles from './backButton.module.scss'
import classnames from 'classnames'

const BackButton = ({ className, onClick = null }) => {
  const history = new HistoryService()

  const handler = onClick || history.goBack

  return (
    <SecondaryButton
      onClick={handler}
      label={backButtonCopy}
      arrow={ButtonArrowState.Backwards}
      style={{ marginTop: '8px' }}
      className={classnames(styles.backButton, className)}
    / >
  );
};

BackButton.propTypes = {};

export default BackButton
